import { LayoutGrid, List } from "lucide-react";
import { Button } from "@/components/ui/button.tsx";

type ViewMode = "cards" | "table";

interface ViewToggleProps {
  view: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

export function ViewToggle({ view, onViewChange }: ViewToggleProps) {
  return (
    <div className="flex items-center border rounded-md">
      <Button
        variant={view === "cards" ? "default" : "ghost"}
        size="icon-sm"
        onClick={() => onViewChange("cards")}
        aria-label="Card view"
        className="rounded-r-none"
      >
        <LayoutGrid className="h-4 w-4" />
      </Button>
      <Button
        variant={view === "table" ? "default" : "ghost"}
        size="icon-sm"
        onClick={() => onViewChange("table")}
        aria-label="Table view"
        className="rounded-l-none"
      >
        <List className="h-4 w-4" />
      </Button>
    </div>
  );
}
